import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';

export const GATE_DEFINITIONS = {
  builderWorker: gate('DpgDevexAgents:BuilderWorker'),
};

function getGates() {
  try {
    return userInfoSync().gates;
  } catch {
    return [];
  }
}

export function useGates() {
  const gates = getGates();

  return useMemo(
    () =>
      Object.fromEntries(
        Object.entries(GATE_DEFINITIONS).map(([k, g]) => [k, gates.includes(g)])
      ) as Record<keyof typeof GATE_DEFINITIONS, boolean>,
    [gates]
  );
}
